import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
import { NoteDialogComponent } from './dialog/note-dialog.component'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,
NoteService
 } from '../../../../services'


import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'note'

@Component({
  selector: 'atyl-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/note',
  key: KEY,
})
export class NoteComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() instruction: any;
  
  activeButton:boolean=false;

  forms:any[]=[];
  
  nodeCount:number=0;

  associateButton:boolean=true;

  

  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
     private noteService: NoteService
  ) { }

  ngOnInit() {
	  
	  this.loading.subscribe((dossier)=>{
			  if (dossier) {
				  console.log("personne dossier change ",dossier);
				this.dossier=dossier;
				this.loadNote();
				}
		 });
	  
	 	
      this.loadNote();
    
  }
  
   loadNote() {
	   console.log(" NoteComponent load ",this.dossier,this.instruction);	
	   
	   let _opts:any={
		   
	   }
	   if (this.dossier!=undefined && this.dossier.ID!=undefined)
	     _opts["dossier"]=this.dossier.ID;
	    if (this.instruction!=undefined && this.instruction.ID!=undefined)
	     _opts["instruction"]=this.instruction.ID;
	    
	   this.noteService.get(_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("NoteComponent loaded",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.nodeCount=res.result.length;
					this.detectChanges();
				}
					
			}
	   );
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
   	note(event:any) {
	    const dialogRef = this.dialogService.open(NoteDialogComponent, {
            data: {
               
                dossier: this.dossier,
                instruction: this.instruction
            },
            draggable: false,
            resizable: false,
            height: '90vh',
			width: "90vw",
        })
        
         dialogRef.afterClosed().subscribe(result => {
            this.loadNote();
        });
	   
    }
   
  

}
